import createClient from "openapi-fetch";

import { API_BASE_URL } from "@/config";
import type { paths } from "@/types/api-schema";

import { authMiddleware } from "./middlewares";

export { apiPublicClient } from "./public-client";

export const apiClient = createClient<paths>({ baseUrl: API_BASE_URL });
apiClient.use(authMiddleware);
